import { Info, ArrowDownUp } from 'lucide-react'
import { MoneySend } from 'iconsax-react'
import { formatMoneyValue } from '../../app/utils/formatMoneyValue'

type TransactionDetailsProps = {
  quantityPaid: number
  commissionTotal: number
}

export const TransactionDetails = ({
  quantityPaid,
  commissionTotal,
}: TransactionDetailsProps) => {
  return (
    <div className="mt-4 flex items-center justify-between gap-4 p-0">
      <div className="relative h-24 w-full rounded-lg border-[1px] border-gray02 bg-white02 px-3 py-2">
        <div className="flex justify-end">
          <div className="absolute right-3 top-2 h-4 p-0">
            <Info size={16} color="black" />
          </div>
        </div>
        <div className="mt-4 flex flex-col items-center justify-center">
          <MoneySend size="24" className="mb-2" />
          <p className="text-xs font-semibold">
            {formatMoneyValue(commissionTotal || 0)}
          </p>
          <p className="text-[10px] font-medium">Total em Propostas pagas</p>
        </div>
      </div>
      <div className="relative h-24 w-full rounded-lg border-[1px] border-gray02 bg-white02 px-3 py-2">
        <div className="flex justify-end">
          <div className="absolute right-3 top-2 h-4 p-0">
            <Info size={16} color="black" />
          </div>
        </div>
        <div className="mt-4 flex flex-col items-center justify-center">
          <ArrowDownUp size={24} className="mb-2" />
          <p className="text-xs font-semibold">{quantityPaid || 0}</p>
          <p className="text-[10px] font-medium">
            Quantidade de Propostas Pagas
          </p>
        </div>
      </div>
    </div>
  )
}
